export default __webpack_public_path__ + "static/media/question_small.efd33fc3.svg";